import { useState, useEffect, useMemo, useCallback, useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';
import DataTable from '../../../component/wallet/data-table/DataTable';
import DataTableToolbar from '../../../component/wallet/data-table/DataTableToolbar';
import { useAdmin } from '../../../Hooks/wallet/useadmin';
import { useDebounce } from '../../../Hooks/wallet/usedebounce';
import { formatDate } from '../../../lib/wallet/utils';
import { DEFAULT_PAGE_SIZE } from '../../../lib/wallet/constants';

const columnHelper = createColumnHelper();

const UsersPage = () => {
    const { sidebar } = useContext(AppContext);
    const navigate = useNavigate();
    const { loading, fetchUsers } = useAdmin();
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 300);
    const [pagination, setPagination] = useState({ page: 1, limit: DEFAULT_PAGE_SIZE, total_count: 0, total_pages: 1 });

    const loadUsers = useCallback(
        async (page = 1) => {
            try {
                const res = await fetchUsers({
                    search: debouncedSearch || undefined,
                    page,
                    limit: pagination.limit,
                });
                setUsers(res?.data?.users || []);
                setPagination((prev) => ({ ...prev, page, ...res?.data?.pagination }));
            } catch {
                // handled
            }
        },
        [debouncedSearch, pagination.limit, fetchUsers]
    );

    useEffect(() => {
        loadUsers(1);
    }, [debouncedSearch]); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = useMemo(
        () => [
            columnHelper.accessor('id', { header: 'ID', size: 60 }),
            columnHelper.accessor('full_name', { header: 'Name' }),
            columnHelper.accessor('email', { header: 'Email' }),
            columnHelper.accessor('phone', { header: 'Phone' }),
            columnHelper.accessor('source_app', { header: 'Source App' }),
            columnHelper.accessor('created_at', {
                header: 'Created',
                cell: (info) => formatDate(info.getValue()),
            }),
        ],
        []
    );

    return (
        <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
            <div className="role-content-main">
            <div className="sub-header-role mb-4">
                <h6 className="mt-2 role-text">Users</h6>
            </div>
                <div className="fade-in">
            

            <DataTableToolbar
                searchValue={search}
                onSearchChange={setSearch}
                searchPlaceholder="Search users…"
            />

            <DataTable
                columns={columns}
                data={users}
                loading={loading}
                page={pagination.page}
                pageSize={pagination.limit}
                totalCount={pagination.total_count}
                totalPages={pagination.total_pages}
                onPageChange={(p) => loadUsers(p)}
                onPageSizeChange={(s) => setPagination((prev) => ({ ...prev, limit: s }))}
                onRowClick={(row) => navigate(`/admin/users/${row.id}`)}
                emptyTitle="No users found"
                emptyDescription="Try a different search term."
            />
        </div>
        </div>
        </div>
    );
};

export default UsersPage;
